<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('orders')">{{__('Orders')}}</inertia-link>
      <span class="text-indigo-400 font-medium">/</span> {{__('Create')}}
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-9xl">

        <div class="p-8 -mr-6 -mb-8 flex flex-wrap" v-if="!confirmOrder && !getAddress">
          <div class="cards" style="float:left;" v-for="labelT in labels" :key="labelT.id" 
            :style="{ backgroundImage:`url(/storageThumbnail/${labelT.thumbnail_path})`, backgroundSize: `75% auto`, backgroundPositionY: `5px`}"
             v-on:click="selectLabel(labelT.id, labelT.price_per_1k, labelT.unit, labelT.label_name, labelT.thumbnail_path, labelT.ribbon)" 
             v-bind:class = "[label_id == labelT.id ?'selectedNew':'labelFile',(labelT.id > 0 && labelT.id < 7) ?'custbg':(labelT.id == 0 ? 'custbg60':'')]"
             v-if="labelT.price_per_1k > 0">
              <p style="background: white; padding: 5px;">
                <ul>
                  <li class="p-1">{{ labelT.label_name }} </li> 
                  <li> ({{ labelT.price_per_1k }}€/{{ labelT.unit }})</li>
                  <!-- <li class="p-1">{{ labelT.organization.name }}</li> -->
                </ul>
              </p>
              <!-- <div class="bottom-bar">
                  <a :href="'/storageFile/'+labelT.file_path" target="_blank" title="View Label File" >
                    <icon name="view" class="block w-6 h-6 fill-indigo-400" />
                  </a>
              </div> -->
          </div>
         
            
        </div>

      <form @submit.prevent="store">

        <div class="p-8 -mr-6 -mb-8 flex flex-wrap" v-if="label_id != null">
            <div class="p-8 -mr-6 -mb-8 flex-wrap lg:w-1/3">
              <p  v-for="labelT in labels"
                  v-if="labelT.id == label_id">
                  {{__(labelT.description)}} {{ labelT.unit }} {{ labelT.label_name }}
              </p> 
            </div>
          <div class="p-8 -mr-6 -mb-8 flex-wrap lg:w-1/3" >
            <select-input v-model="quantity" :error="form.errors.quantity" class="pr-6 pb-8 w-full" :label="__('Quantity')">
              <option :value="1"> 1 </option>
              <option :value="2"> 2 </option>
              <option :value="3"> 3 </option>
              <option :value="4"> 4 </option>
              <option :value="5"> 5 </option>
              <option :value="6"> 6 </option>
              <option :value="7"> 7 </option>
              <option :value="8"> 8 </option>
              <option :value="9"> 9 </option>
              <option :value="10"> 10 </option>
            </select-input>
          </div>
          <div class="p-8 -mr-6 -mb-8 flex-wrap lg:w-1/3" >
            <button v-on:click="updateOrderDetails()" type="button" class="btn-indigo" >{{__('Add')}} </button>
          </div>
        </div> 
        
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap max-w-6xl" style="margin-bottom:4rem;display:block;" v-if="!confirmOrder && !getAddress">
           <div class="bg-white rounded-md shadow overflow-x-auto">
              <table class="w-full whitespace-nowrap">
                   <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                      <th class="border-t border-r px-6 pt-6 pb-4 font-bold text-left">{{__('Order Items')}}</th>
                      <td class="border-t px-2 pt-1 pb-1 text-left">
                        <div  v-if="this.form.orderDetails.length > 0" >
                          <span class="p-2 flex flex-wrap max-w-6xl" style="padding:30px; height:80px;" v-for="order, indx in this.form.orderDetails" :key="indx"> 
                              <span v-if="order[6]">
                                {{getBoxes(1)}} ({{order[1]*10}} {{__('Ribbons')}})
                              </span>
                              <span v-else>
                                {{getBoxes(order[1])}} - ({{order[1]*order[3]}} {{order[4]}})
                              </span>
                          </span>
                        </div>
                      </td>
                      <td class="border-t px-2 pt-1 pb-1 text-left">
                        <div  v-if="this.form.orderDetails.length > 0" >
                          <span class="py-2 flex flex-wrap max-w-6xl" v-for="order, indx in this.form.orderDetails" :key="indx"> 
                            <img v-if="order[5].length > 4" :src="'/storageThumbnail/'+order[5]" style="width: 100px;" />
                          </span>
                        </div>
                      </td>
                      <td class="border-t px-2 pt-1 pb-1 text-left">
                        <div  v-if="this.form.orderDetails.length > 0" >
                          <span v-on:click="removeOrderItem(indx)" class="py-2 flex flex-wrap max-w-6xl pointer" v-for="order, indx in this.form.orderDetails">
                              <icon name="trash" class="block w-6 h-6 fill-red-400" />
                          </span>
                        </div>
                      </td>
                    </tr>
              </table>
           </div>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center" v-if="!confirmOrder && !getAddress">
          <button class="btn-indigo" v-on:click="updateConfirm(true)" type="button">{{__('Review')}} & {{__('Confirm')}} </button>
        </div>
         <div class="p-8 -mr-6 -mb-8 flex flex-wrap max-w-6xl" style="margin-bottom:4rem;display:block;" v-if="confirmOrder">
           <div class="bg-white rounded-md shadow overflow-x-auto">
              <table class="w-full whitespace-nowrap">
                  <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <th class="border-t border-r px-6 pt-6 pb-4 font-bold text-left">  {{__('Invoice')}} {{__('Address')}} </th>
                    <td class="border-t px-6 pt-6 pb-4 text-left" colspan="2"> 
                      {{(contact_details.address?contact_details.address:address)}}, 
                      {{contact_details.city}}, 
                      {{country}}, 
                      {{(contact_details.postal_code?contact_details.postal_code:postal_code)}}
                    </td>
                  </tr>
                   <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                      <th class="border-t border-r px-6 pt-6 pb-4 font-bold text-left">{{__('Order Items')}}</th>
                      <td class="border-t px-2 pt-1 pb-1 text-left">
                        <div  v-if="this.form.orderDetails.length > 0" >
                          <span class="p-2 flex flex-wrap max-w-6xl" style="padding:30px; height:80px;" v-for="order, indx in this.form.orderDetails" :key="indx"> 
                              <span v-if="order[6]">
                                {{getBoxes(1)}} ({{order[1]*10}} {{__('Ribbons')}})
                              </span>
                              <span v-else>
                                {{getBoxes(order[1])}} - ({{order[1]*order[3]}} {{order[4]}})
                              </span>
                          </span>
                        </div>
                      </td>
                      <td class="border-t px-2 pt-1 pb-1 text-left">
                        <div  v-if="this.form.orderDetails.length > 0" >
                          <span class="py-2 flex flex-wrap max-w-6xl" v-for="order, indx in this.form.orderDetails" :key="indx"> 
                            <img v-if="order[5].length > 4" :src="'/storageThumbnail/'+order[5]" style="width: 100px;" />
                          </span>
                        </div>
                      </td>
                    </tr>
                  <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <th class="border-t border-r px-6 pt-6 pb-4 font-bold text-left">  {{__('Shipping')}} {{__('Address')}} </th>
                    <td class="border-t px-6 pt-6 pb-4 text-left" colspan="2" v-if="false" >
                      {{shipping_address_data.address}},
                      {{shipping_address_data.city}},  
                      {{shipping_address_data.country}}, 
                      {{shipping_address_data.postal_code}}   
                    </td>
                    <td class="border-t px-6 pt-6 pb-4 text-left" colspan="2" v-else >
                      {{shipping_address}}, 
                      {{shipping_city}},  
                      {{country}}, 
                      {{shipping_postal_code}}   
                    </td>
                  </tr>
                  <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                      <th class="border-t border-r px-6 pt-6 pb-4 font-bold text-left">{{__('Shipping')}} {{__('Fee')}}</th>
                      <td class="border-t px-6 pt-6 pb-4 text-left" colspan="2"> {{this.shippingFee}} € </td>
                    </tr>
                  <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                      <th class="border-t border-r px-6 pt-6 pb-4 font-bold text-left"> {{__('Total Cost')}} excl. btw</th>
                      <td class="border-t px-6 pt-6 pb-4 text-left" colspan="2"> {{this.form.orderCost}} € </td>
                    </tr>
              </table>
           </div>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center" v-if="confirmOrder">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{__('Order')}}</loading-button>
          <button class="btn-indigo" style="margin:5px; background: grey;" v-on:click="updateConfirm(false)" type="button">{{__('Cancel')}} </button>
        </div>
      </form>
    </div>

    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl" v-if="getAddress">
      <div class="p-8 -mr-6 -mb-8 flex-wrap lg:w-1/1" style="margin:5px;">
        <span>
          <p style="color:red;"> {{__('Please complete your profile by providing below details to complete the order.')}}</p>
        </span>
      </div>
      <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <!-- Missing Profile Details -->
          <text-input v-model="first_name" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('First Name')" v-if="checkAddress['first_name']"/>
          <text-input v-model="last_name" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Last Name')" v-if="checkAddress['last_name']"/>
          <text-input v-model="business_name" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Business Name')" v-if="checkAddress['business_name']"/>
          <text-input v-model="address" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Invoice Address street + Number')" />
          <text-input v-model="city" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('City')"  />
          <!-- <text-input v-model="region" class="pr-6 pb-8 w-full lg:w-1/2" label="Province/State" v-if="checkAddress['region']" /> -->
          <select-input v-model="country" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Country')"  >
            <option :value="null" > {{__('Select Country')}} </option>
            <option v-for="(countryItem, index) in $page.props.countries" :key="index" :value="countryItem.iso2">{{countryItem.name}}</option>
          </select-input>
          <text-input v-model="postal_code" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Postal code')"  />
          <text-input v-model="phone" :class="(phone?'':'clsRed')" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Phone')+' - (xxx xxxxxx)'" v-if="checkAddress['phone']" />

          <text-input v-model="vat_no" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('VAT No')" v-if="checkAddress['vat_no']" />

          <!-- Shipping Address -->
          <!-- <div v-if="sameAsInvoice">
              <input
                type="checkbox"
                name="sameAsInvoive"
                :value="sameAsInvoive"
                v-model="sameAsInvoive"
                style="margin-right: 10px;"
              />
              <label for="sameAsInvoive">{{__('Shipping Address Same As Invoice')}}</label>
          </div> -->
          <!-- <div v-else> -->
            </div>
            <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
            <text-input v-model="shipping_address" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Shipping Address street + Number')" />
            <text-input v-model="shipping_city" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('City')"  />
            <!-- <select-input v-model="country" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Country')"  >
              <option :value="null" > {{__('Select Country')}} </option>
              <option v-for="(countryItem, index) in $page.props.countries" :key="index" :value="countryItem.iso2">{{countryItem.name}}</option>
            </select-input> -->
             <text-input v-model="shipping_postal_code" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Postal code')"  /> 
            <!-- 
              <input
                type="checkbox"
                name="sameAsInvoive"
                :value="sameAsInvoive"
                v-model="sameAsInvoive"
                style="margin-right: 10px;"
              />
              <label for="sameAsInvoive">{{__('Shipping Address Same As Invoice')}}</label> -->
          <!-- end shipping address -->

      </div>
        <div class="p-8 -mr-6 -mb-8 flex-wrap lg:w-1/1" style="margin:5px;text-align: right;">
          <button v-on:click="updateProfile()" type="button" class="btn-indigo" >{{__('bewaar')}} </button>
        </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Pdf from 'vue-pdf'
import axios from 'axios'



export default {
  metaInfo: { title: 'Create Order' },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    Pdf,
    Icon,
  },
  created(){
    // console.log(this.shipping_address)
  },
  layout: Layout,
  props: {
    labels: Array,
    contact_details: Object,
    shipping_address_data: Object
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        orderDetails : [],
        orderCost: 0,
        orderQuantity : 0,
        ribbonDetails: [],
      }),
      quantity: null,
      label_id: null,
      labelPricePer1k: null,
      labelUnit: null,
      label_name: null,
      thumbnail_path: null,
      ribbon: false,
      extraRibbons: 0,
      shippingFee: 20,
      ribbonDetails: [],
      shippingAddress: (this.contact_details.shipping_address_id?true:false),
      confirmOrder: false,
      getAddress: false,
      first_name: null,
      last_name: null,
      business_name: null,
      address: null,
      city: null,
      // region: null,
      country: null,
      postal_code: null,
      sameAsInvoice: 1,
      vat_no: null,
      phone: null,
      shipping_address: (this.shipping_address_data?this.shipping_address_data.address:null),
      shipping_city: (this.shipping_address_data?this.shipping_address_data.city:null),
      shipping_postal_code: (this.shipping_address_data?this.shipping_address_data.postal_code:null),
      checkAddress: []
    }
  },
mounted(){
  // console.log(this.labels)
//   console.log(this.contact_details)
},
filters: {
  	subStr: function(string) {
    	return string.substring(0,15) + '...';
        },
      numberFormate: function(val){
        return parseInt(val).toLocaleString()
      }
},
  methods: {
    store() {
      
        // if(this.ribbonDetails.length > 0 && this.ribbonDetails[1] > 0){
        //    this.form.ribbonDetails.push([this.ribbonDetails[0], this.ribbonDetails[1], this.ribbonDetails[2], this.ribbonDetails[3], this.ribbonDetails[4]])
        //    this.form.orderQuantity = (parseInt(this.form.orderQuantity)+ 1)
        // }
        // console.log(this.form)

        // if(this.form.orderDetails.length < 1 && this.form.ribbonDetail < 1) {
        if(this.form.orderDetails.length < 1) {
          alert('Please Add a label and Quantity')
        } else {
            this.form.post(this.route('orders.store'))
        }
    },
    updateOrderDetails(){
      if(this.label_id == null) {
            alert('Please select a label')
        } else if(this.quantity == null) {
            alert('Please select quantity.')
        } else {
          this.form.orderDetails.push([this.label_id, this.quantity, this.labelPricePer1k, this.labelUnit, this.label_name, this.thumbnail_path, this.ribbon])
          this.updateOrderCost().then(() => {
            this.label_id = null
            this.quantity = null
            this.labelPricePer1k = null
            this.labelUnit = null
            this.label_name = null
            this.thumbnail_path = null
            this.ribbon = false
            // console.log(this.form)
          })  
        }
    },
    removeOrderItem(indx){
      
      // update order cost and quantity
     this.form.orderCost = ((parseFloat(this.form.orderCost)-parseFloat((this.form.orderDetails[indx][1] * this.form.orderDetails[indx][2])))).toFixed(2)
     this.form.orderQuantity = (parseInt(this.form.orderQuantity)- parseInt(this.form.orderDetails[indx][1]))

      // remove item from order details array
      this.form.orderDetails.splice(indx, 1);

    },
    selectLabel(labelId, price_per_1k, unit, label_name, thumbnail_path, ribbon){
        this.label_id = labelId
        this.labelPricePer1k = price_per_1k
        this.labelUnit = unit
        this.label_name = label_name
        this.thumbnail_path = thumbnail_path
        this.ribbon = ribbon
    },
    async updateConfirm(check){
        if(this.form.orderDetails.length < 1){
            alert('Please add a product with quantity.')
        }else{

          if(check){
            // check if profile is completed or display a popup to add missing details.
            let self = this
            await axios.get('/missing').then(function (response) {
              
                    if(response.data){

                      if(response.data.first_name){
                        self.first_name = response.data.first_name
                      }else{
                        self.checkAddress['first_name'] = true;
                        self.getAddress = true
                      }

                      if(response.data.last_name){
                        self.last_name = response.data.last_name
                      }else{
                        self.checkAddress['last_name'] = true;
                        self.getAddress = true
                      }

                      if(response.data.business_name){
                        self.business_name = response.data.business_name
                      }else{
                        self.checkAddress['business_name'] = true;
                        self.getAddress = true
                      }

                      if(response.data.address){
                        self.address = response.data.address
                      }else{
                        self.checkAddress['address'] = true;
                        self.getAddress = true
                      }
                      if(response.data.city){
                        self.city = response.data.city
                      }else{
                        self.checkAddress['city'] = true;
                        self.getAddress = true
                      }
                      // if(response.data.region){
                      //   self.region = response.data.region
                      // }else{
                      //   self.checkAddress['region'] = true;
                      // }
                      if(response.data.country){
                        self.country = response.data.country
                      }else{
                        self.checkAddress['country'] = true;
                        self.getAddress = true
                      }
                      if(response.data.postal_code){
                        self.postal_code = response.data.postal_code
                      }else{
                        self.checkAddress['postal_code'] = true;
                        self.getAddress = true
                      }
                      if(response.data.phone){
                        self.phone = response.data.phone
                      }else{
                        self.checkAddress['phone'] = true;
                        self.getAddress = true
                      }
                      if(response.data.vat_no){
                        self.vat_no = response.data.vat_no
                      }else{
                        self.checkAddress['vat_no'] = true;
                        self.getAddress = true
                      }

                      if(!self.getAddress)
                        self.confirmOrder = check
    
                    }else{
                      self.confirmOrder = check
                      self.getAddress = false
                    }
                  }).catch(function (error) {
                    // handle error
                    console.log(error)
                  }).finally(function () {
                    // always executed
                  });

          }else{
            this.confirmOrder = check
          }
        }
          
    },
    async updateProfile(){

      if(this.first_name == null || this.first_name.length < 1 || this.last_name == null || this.business_name == null || this.last_name.length < 1 || this.address == null || this.address.length < 3 
      || this.city == null ||  this.city.length < 2 || this.country == null || this.postal_code == null ||  this.postal_code.length < 3 
      || this.phone == null ||   this.phone.length < 6 || this.vat_no == null ||   this.vat_no.length < 3 || this.shipping_address == null ||   this.shipping_address.length < 3 
      || this.shipping_city == null ||   this.shipping_city.length < 2 || this.shipping_postal_code == null ||   this.shipping_postal_code.length < 3){
          alert('Some Details are missing or incomplete. Please fill All the details.')
      }else if(this.phone.length < 6){
            alert('Phone no must be atleast 7 digits.')
      }else{

        let self = this        
        await axios.post('/updatemissing', 
          {
              first_name: this.first_name,
              last_name: this.last_name,
              business_name: this.business_name,
              address: this.address, 
              city : this.city, 
              country : this.country, 
              postal_code : this.postal_code, 
              vat_no : this.vat_no,
              phone : this.phone,
              shipping_address : this.shipping_address,
              shipping_city : this.shipping_city,
              shipping_postal_code: this.shipping_postal_code
          }).then(function (response) {
            // console.log(response)
          if(response){
            self.getAddress = false
            self.confirmOrder = true
          }
        }).catch(function (error) {
          // handle error
          // console.log(error)
        });
      }
        
    },
    updateOrderCost(){
      return new Promise((resolve, reject) => {
        if(this.quantity != null && this.label_id == null){
          alert('Please select a label')
        }else{
          if(this.ribbon){
            if(this.form.orderCost < 1){
              this.form.orderCost = (this.quantity * this.labelPricePer1k).toFixed(2)
              this.form.orderQuantity = 1
            }else{
              this.form.orderCost = (parseFloat(this.form.orderCost)+parseFloat((this.quantity * this.labelPricePer1k).toFixed(2))).toFixed(2)
              this.form.orderQuantity = (parseInt(this.form.orderQuantity)+parseInt('1'))
            }
          }else{
            if(this.form.orderCost < 1){
              this.form.orderCost = ((this.quantity * this.labelPricePer1k)+parseInt(this.shippingFee)).toFixed(2)
              this.form.orderQuantity = this.quantity
            }else{
              this.form.orderCost = ((parseFloat(this.form.orderCost)+parseFloat((this.quantity * this.labelPricePer1k)))).toFixed(2)
              this.form.orderQuantity = (parseInt(this.form.orderQuantity)+parseInt(this.quantity))
            }
          }
        }
        resolve()
      })
    },
    getBoxes(quantity){
       if(quantity == 1){
        return '1 stuk'
      }else{
        return quantity+' stuks'
      }
    },
    addExtraRibbons(){
      this.extraRibbons = this.extraRibbons + 10

      // alert(this.form.orderDetails.findIndex(arr => arr.includes(0)))

     if(this.ribbonDetails.length > 0 && this.ribbonDetails[1] > 0){
       this.ribbonDetails[1] = (parseInt(this.ribbonDetails[1]) + 1)
       this.ribbonDetails[2] = (parseInt(this.ribbonDetails[2]) + 80)
     }else{
      this.ribbonDetails = [0, 1, 80, 'Ribbons', 'extraribbons.png']
     }

     this.form.orderCost = (parseFloat(this.form.orderCost + 80)).toFixed(4)

    //  console.log(this.ribbonDetails);

      if(this.form.orderCost < 1){
        this.form.orderCost = (this.form.orderCost + 80).toFixed(4)
      }else{
        this.form.orderCost = (parseFloat(this.form.orderCost) + 80).toFixed(4)
      }
    },
    remove10ExtraRibbons(){
      this.extraRibbons = this.extraRibbons - 10

      if(this.ribbonDetails.length > 0 && this.ribbonDetails[1] > 0){
        this.ribbonDetails[1] = (parseInt(this.ribbonDetails[1]) - 1)
        this.ribbonDetails[2] = (parseInt(this.ribbonDetails[2]) - 80)
      }else{
        this.ribbonDetails = []
      }

      // console.log(this.ribbonDetails);

      if(this.form.orderCost < 1){
        this.form.orderCost = (this.form.orderCost - 80).toFixed(4)
      }else{
        this.form.orderCost = (parseFloat(this.form.orderCost) - parseFloat(80).toFixed(4)).toFixed(4)
      }
    },
    removeExtraRibbons(){
      this.extraRibbons = 0
    }
  }
}
</script>
<style scoped>
.labelFile{
  /* filter: gray; 
      -webkit-filter: grayscale(1); 
      -webkit-transition: all .8s ease-in-out; */
    min-height: 160px;
    display: inline-block;
}

.cards{
  width:215px;
  height:240px;
  background:#fff;
  margin:20px;
  border-radius:0.375rem;
  /* box-shadow:0px 0px 15px 0px #313131; */
  border: 1.5px solid #e2e8f0;
  background-size:102%;
  background-repeat:no-repeat;
  background-position:top center;
  position:relative;
  overflow:hidden;
}
.bottom-bar{
  width:100%;
  height:45px;
  position:absolute;
  bottom:-100%;
  background:#fff;
  transition:all 0.3s;
  text-align:center;
  display:flex;
  justify-content:center;
  align-items:center;
  z-index:99;
  border-top:1px solid #3333;
}
.cards:hover .bottom-bar{
  bottom:0px;
}
.cards a{
  cursor:pointer;
  padding:5px 10px;
  border-radius:4px;
  color:whitesmoke;
}
.cards a:hover{
  background:#3333;
  color:white;
}
.cards p{
  text-align:center;
  position:absolute;
  width:100%;
  bottom:5px;
  /* font-size:18px; */
  color:#39415a;
}

.pointer{
  cursor: pointer;
}
.selected{
    border: #2f365f 2px solid;
    border-radius: 8px;
    background-color: #535c8a;
    color: #ffffff;
    min-height: 160px;
    display: inline-block;
}
.selectedNew{
    border: #2f365f 3px solid;
    border-radius: 8px;
    /* background-color: #535c8a; */
    color: #ffffff;
    min-height: 160px;
    display: inline-block;
}
.selectedIcon{
  fill: #ffffff;
}
.labelFile:hover {
  filter: none;
      -webkit-filter: grayscale(0);
      -webkit-transform: scale(1.01);
      cursor: pointer;
}
.selectedImg{
  filter: none;
      -webkit-filter: grayscale(0);
      -webkit-transform: scale(1.01);
}
.custbg{
  background-size: 92% auto !important;
 }
 .custbg60{
  background-size: 60% auto !important;
 }

/* span {cursor:pointer; } */
		.minus, .plus{
      cursor:pointer;
			width:32px;
			height:44px;
			background:#f2f2f2;
			border-radius:4px;
			padding:11px 5px 8px 5px;
			border:1px solid #ddd;
      display: inline-block;
      vertical-align: middle;
      text-align: center;
		}
		.ribbons-input{
			height:44px;
      width: 75px;
      text-align: center;
      font-size: 16px;
			border:1px solid #ddd;
			border-radius:4px;
      display: inline-block;
      vertical-align: middle;
    }
    .empyInput{
        border: 1px solid red;
    }

    .clsRed{
      color: red;
    }

@media screen and (min-width: 580px) {
    .dbr{
      display:block ruby;
    }
 }
</style>
